import { Navigate, Route, useLocation } from "react-router-dom";
import CustomerLayout from "../customer/customerLayout";
import { lazyPage } from "../shared/lazyPage";

const CaregiverDashboard = lazyPage(() => import("./CaregiverDashboard"));
const CaregiverSchedule = lazyPage(() => import("./CaregiverSchedule"));
const CaregiverStartEndService = lazyPage(() => import("./CaregiverStartEndService"));
const CaregiverMySchedule = lazyPage(() => import("./CaregiverMySchedule"));
const CaregiverAvailabilityCalendar = lazyPage(() => import("./CaregiverAvailabilityCalendar"));
const CaregiverCareNotes = lazyPage(() => import("./CaregiverCareNotes"));
const CaregiverAddDailyNote = lazyPage(() => import("./CaregiverAddDailyNote"));
const CaregiverBookingDetails = lazyPage(() => import("./CaregiverBookingDetails"));
const CaregiverBookingSummary = lazyPage(() => import("./CaregiverBookingSummary"));
const CaregiverServiceSummary = lazyPage(() => import("./CaregiverServiceSummary"));
const CaregiverMyAvailability = lazyPage(() => import("./CaregiverMyAvailability"));
const CaregiverProfileLevel = lazyPage(() => import("./CaregiverProfileLevel"));
const CaregiverEarnings = lazyPage(() => import("./CaregiverEarnings"));
const CaregiverPricingPackages = lazyPage(() => import("./CaregiverPricingPackages"));
const CaregiverCompleteProfile = lazyPage(() => import("./CaregiverCompleteProfile"));
const CaregiverRegistrationStepper = lazyPage(() => import("./CaregiverRegistrationStepper"));
const CaregiverOnboarding = lazyPage(() => import("./CaregiverOnboarding"));
const CaregiverMyBookings = lazyPage(() => import("./CaregiverMyBookings"));
const CaregiverSubscription = lazyPage(() => import("./CaregiverSubscription"));
const CaregiverPayments = lazyPage(() => import("./CaregiverPayments"));
const CaregiverEngagementDetails = lazyPage(() => import("./CaregiverEngagementDetails"));
const CaregiverSupportTickets = lazyPage(() => import("./CaregiverSupportTickets"));
const PhysioComplianceOnboarding = lazyPage(() => import("./physio/PhysioComplianceOnboarding"));
const NotificationsPage = lazyPage(() => import("../../pages/NotificationsPage"));
const MessengerPage = lazyPage(() => import("../../pages/MessengerPage"));

/** Old Start service URL → new Start / End Service screen. */
function RedirectLegacyStartService() {
  const location = useLocation();
  return <Navigate to={`/caregiver/start-end-service${location.search || ""}`} replace />;
}

export function renderCaregiverRoutes() {
  return (
    <>
      <Route path="/caregiver/register" element={<CaregiverRegistrationStepper />} />
      <Route element={<CustomerLayout role="caregiver" />}>
        <Route path="/caregiver/complete-profile" element={<CaregiverCompleteProfile />} />
        <Route path="/caregiver/compliance-onboarding" element={<PhysioComplianceOnboarding />} />
        <Route path="/caregiver/submit-kyc" element={<Navigate to="/caregiver/complete-profile" replace />} />
        <Route path="/caregiver/police-document" element={<Navigate to="/caregiver/complete-profile" replace />} />
        <Route path="/caregiver/approval-status" element={<CaregiverOnboarding />} />
        <Route path="/caregiver/my-bookings" element={<CaregiverMyBookings />} />
        <Route path="/caregiver/engagements/:bookingId" element={<CaregiverEngagementDetails />} />
        <Route path="/caregiver/bookings/:bookingId" element={<CaregiverBookingDetails />} />
        <Route
          path="/caregiver/bookings/:bookingId/summary"
          element={<CaregiverBookingSummary />}
        />
        <Route
          path="/caregiver/bookings/:bookingId/service-summary"
          element={<CaregiverServiceSummary />}
        />
        <Route path="/caregiver/my-availability" element={<CaregiverMyAvailability />} />
        <Route path="/caregiver/notifications" element={<NotificationsPage role="CAREGIVER" />} />
        <Route path="/caregiver/messenger" element={<MessengerPage role="CAREGIVER" />} />
        <Route path="/caregiver/hourly-bookings" element={<RedirectLegacyStartService />} />
        <Route path="/caregiver/start-end-service" element={<CaregiverStartEndService />} />
        <Route path="/caregiver/my-schedule" element={<CaregiverMySchedule />} />
        <Route path="/caregiver/availability" element={<CaregiverAvailabilityCalendar />} />
        <Route path="/caregiver/availability/month" element={<CaregiverAvailabilityCalendar />} />
        <Route path="/caregiver/availability/manage" element={<CaregiverSchedule />} />
        <Route path="/caregiver/availability/edit" element={<Navigate to="/caregiver/availability/manage" replace />} />
        <Route path="/caregiver/care-notes" element={<CaregiverCareNotes />} />
        <Route path="/caregiver/care-notes/add" element={<CaregiverAddDailyNote />} />
        <Route path="/caregiver/schedule" element={<Navigate to="/caregiver/availability" replace />} />
        <Route path="/caregiver/profile-level" element={<CaregiverProfileLevel />} />
        <Route path="/caregiver/subscription" element={<CaregiverSubscription />} />
        <Route path="/caregiver/payments" element={<CaregiverPayments />} />
        <Route path="/caregiver/support" element={<CaregiverSupportTickets />} />
        <Route path="/caregiver/earnings" element={<CaregiverEarnings />} />
        <Route path="/caregiver/pricing" element={<CaregiverPricingPackages />} />
        <Route path="/caregiver" element={<CaregiverDashboard />} />
      </Route>
    </>
  );
}
